import React from 'react';
/** @jsx jsx */
import {jsx, css} from '@emotion/core';
import ogp_ishii from '../img/ogp-ishii.png';
import ogp_kakegawa from '../img/ogp-kakegawa.png';
import ogp_matsuda from '../img/ogp-matsuda.png';
import ogp_tamaki from '../img/ogp-tamaki.png';
import ogp from '../img/ogp.jpg';

const m = {
  'r-kakegawa': ogp_kakegawa,
  's-matsuda': ogp_matsuda,
  'y-tamaki': ogp_tamaki,
  'r-ishii': ogp_ishii,
}

const blogOgp = (post) => {
  if (post.og_image) {
    return post.og_image;
  }
  return m[post.talent.id] || ogp;
}

export default blogOgp;